import * as React from "react";
import styled from "@mui/material/styles/styled";
import { QualifiedFeature, SummaryProblemIcd } from "fe-common/graphql";
import { getQFAndRefinementsLines } from "fe-common/logic";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

//region [[ Styles ]]
const SummaryAssesmentListItemView = styled("div")({
  margin: "8px 0",
  padding: "5px 9px",
  backgroundColor: KahunColorMap.DisabledBackground,
  borderRadius: "14px",
  fontSize: "14px",
  display: "flex",
  flexDirection: "column",
});

const ICDItemsWrapper = styled("div")({
  display: "flex",
  flexDirection: "row",
});

const ICDItem = styled("div")({
  backgroundColor: KahunColorMap.White,
  borderRadius: "9px",
  padding: "8px",
  margin: "8px",
});

//endregion [[ Styles ]]

//region [[ Props ]]
interface ClusterCardProps {
  qf: QualifiedFeature;
  icd: SummaryProblemIcd[];
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

const SummaryAssesmentListItem = ({ qf, icd }: ClusterCardProps) => (
  <SummaryAssesmentListItemView>
    {getQFAndRefinementsLines(qf).join(" ")}
    <div>
      <ICDItemsWrapper>
        {icd?.map((icd) => (
          <ICDItem>{`${icd.code}: ${icd.desc} `}</ICDItem>
        ))}
      </ICDItemsWrapper>
    </div>
  </SummaryAssesmentListItemView>
);
export default SummaryAssesmentListItem;
